import { jsx as _jsx } from "react/jsx-runtime";
import { useLottie } from "lottie-react";
import pendingAnimation from "./pending-lottie.json";
const style = {
    height: 48,
    width: 48,
};
const PendingAnimation = () => {
    const options = {
        animationData: pendingAnimation,
        loop: true,
        autoplay: true,
    };
    const Lottie = useLottie(options, style);
    return (_jsx("div", Object.assign({ style: {
            // height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        } }, { children: Lottie.View })));
};
export default PendingAnimation;
